import React from 'react';
import { Button, CircularProgress, Typography } from '@material-ui/core';
import PaymentIcon from '@material-ui/icons/Payment';
import { usePOS } from '../../contexts/POSContext';
import { formattedCurrency } from '../../utils/utils';

const POSBottomBar = ({ onOpenCheckout }) => {
  const { totals, cartItems } = usePOS();

  const isCartEmpty = cartItems.length === 0;

  return (
    <div className="pos-footer-bar">
      <div className="pos-footer-totals">
        <div className="pos-footer-total-box">
          <span className="pos-footer-total-label">TOTAL:</span>
          <span className="pos-footer-total-value">
            {formattedCurrency(totals.total)}
          </span>
        </div>

        {totals.totalDiscount > 0 && (
          <div className="pos-footer-discount-box">
            <span>DESCONTOS:</span>
            <span style={{ fontWeight: 700, color: '#2e7d32' }}>
              - {formattedCurrency(totals.totalDiscount)}
            </span>
          </div>
        )}
      </div>

      <div>
        <Button
          variant="contained"
          className="pos-btn-checkout"
          onClick={onOpenCheckout}
          disabled={isCartEmpty}
          startIcon={<PaymentIcon />}
          title="Atalho: F10 ou Shift + Enter"
        >
          Fechar Venda [F10 / Enter]
        </Button>
      </div>
    </div>
  );
};

export default POSBottomBar;
